import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import IconProvider from "@/components/ui/IconProvider";

interface ItalicDropdownProps {
  onFormat: (command: string, value?: string) => void;
}

export const ItalicDropdown = ({ onFormat }: ItalicDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 px-2 hover:bg-gray-100 text-gray-700 hover:text-gray-900 border-r border-gray-200 flex items-center gap-1"
        >
          <IconProvider
            iconstring="fa-italic"
            size={14}
          />
          <IconProvider
            iconstring="fa-chevron-down"
            size={10}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-16">
        <DropdownMenuItem
          onClick={() => onFormat("italic")}
          className="text-sm"
        >
          <IconProvider iconstring="fa-italic" size={14} />
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onFormat("underline")}
          className="text-sm"
        >
          <IconProvider iconstring="fa-underline" size={14} />
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onFormat("strikethrough")}
          className="text-sm"
        >
          <IconProvider iconstring="fa-strikethrough" size={14} />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
